// Super Admin ▸ Deployment & Release ▸ Mobile Apps (spec §9, mockup v6).
import React, { useCallback, useState } from 'react';
import { Smartphone } from 'lucide-react';
import type { MobileAppId } from '@platform/shared-types';
import { InventoryPage, InventorySubtabs } from '../inventory/InventoryChrome';
import { Toast } from '../../components/Toast';
import { currentReleaseEnv } from '../../api/releaseApi';
import { Seg, APPS } from './ui';
import { AppsTab } from './AppsTab';
import { BuildsTab } from './BuildsTab';
import { ProgressTab } from './ProgressTab';
import { FeedbackTab } from './FeedbackTab';

const TABS = [
  { id: 'apps', label: 'Apps & menus' }, { id: 'builds', label: 'Builds' },
  { id: 'progress', label: 'In progress' }, { id: 'feedback', label: 'Feedback' },
];

export default function MobileAppsPage() {
  const [tab, setTab] = useState('apps');
  const [app, setApp] = useState<MobileAppId>('rubytill');
  const [toast, setToast] = useState<{ type: 'success' | 'error'; message: string } | null>(null);
  const env = currentReleaseEnv() ?? 'dev';
  const notify = useCallback((type: 'success' | 'error', message: string) => setToast({ type, message }), []);

  return (
    <InventoryPage icon={Smartphone} title="Mobile Apps" crumb="Deployment & Release"
      subtitle={env === 'prod' ? 'Production' : 'Dev'}
      actions={<Seg<MobileAppId> dark value={app} onChange={setApp} options={APPS} />}
      tabs={<InventorySubtabs tabs={TABS} active={tab} onChange={setTab} />}>
      {tab === 'apps' && <AppsTab key={app} app={app} env={env} notify={notify} />}
      {tab === 'builds' && <BuildsTab key={app} app={app} env={env} notify={notify} onDeployed={() => setTab('progress')} />}
      {tab === 'progress' && <ProgressTab key={app} app={app} env={env} notify={notify} />}
      {tab === 'feedback' && <FeedbackTab key={app} app={app} env={env} />}
      {toast && <div className="fixed bottom-6 left-1/2 z-[60] -translate-x-1/2"><Toast type={toast.type} message={toast.message} onClose={() => setToast(null)} /></div>}
    </InventoryPage>
  );
}
